import { observable } from "mobx";

export class DeliveryLocation {
    @observable id: string;
    @observable name: string;
    @observable fullAddressText: string;

    constructor() {
        this.id = "";
        this.name = "";
        this.fullAddressText = "";
    }
}